export default "__VITE_ASSET__BiWXw7IH__"